module.exports = __webpack_public_path__ + "img/service-vote.46dd97c1.png";